import React from 'react';

import { ReactComponent as Logo } from '../../assets/icons/logo.svg';

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <div className="left-column">
          <a href="/">
            <Logo className='logo' />
          </a>
          <div className="legal hide-mobile">
            <small>
              &copy; Copyright Polygraph 2025, All rights reserved. <br />
              <a href="/privacy-policy">Privacy Policy</a>
              <span> | </span>
              <a href="/terms-of-use">Terms of Use</a>
            </small>
          </div>
        </div>
        <div className="right-column">
          <ul>
            <li className="nav-item">
              <h4>Company</h4>
            </li>
            <li className="nav-item">
              <a href="https://polygraph.net/our-company">Our Company</a>
            </li>
            <li className="nav-item">
              <a href="https://polygraph.net/articles">Articles</a>
            </li>
            <li className="nav-item">
              <a href="https://polygraph.net/careers">Careers</a>
            </li>
            <li className="nav-item">
              <a href="https://polygraph.net/contact-us">Contact Us</a>
            </li>
          </ul>
          <ul>
            <li className="nav-item">
              <h4>Use Cases</h4>
            </li>
            <li className="nav-item">
              <a href="https://polygraph.net/usecases/business-owners">Business Owners</a>
            </li>
            <li className="nav-item">
              <a href="https://polygraph.net/usecases/digital-marketers">Digital Marketers</a>
            </li>
            <li className="nav-item">
              <a href="https://polygraph.net/usecases/sales">Sales Teams</a>
            </li>
            <li className="nav-item">
              <a href="https://polygraph.net/usecases/internal-auditors-and-risk-control">Internal Auditors and Risk Control</a>
            </li>
          </ul>
          <ul>
            <li className="nav-item">
              <h4>Product</h4>
            </li>
            <li className="nav-item">
              <a href="https://polygraph.net/pricing">Pricing</a>
            </li>
            <li className="nav-item">
              <a href="https://polygraph.net/how-it-works">How it works</a>
            </li>
          </ul>

          <div className="legal show-mobile">
            <small>
              <a href="https://polygraph.net/privacy-policy">Privacy Policy</a> |
              <a href="https://polygraph.net/terms-of-use">Terms of Use</a>
              <br />
              &copy; Copyright Polygraph 2025.<br />
              All rights reserved.
            </small>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
